const topPropertyTypeCodes = [22, 16, 5, 6, 12, 1, 17, 14];

// 8 (All-inclusive) and 23 (Condominium resort) are deprecated structure types (CAM-1122, CAM-1107)
const bottomPropertyTypeCodes = [40, 9, 43, 24, 36, 10, 7,
    11, 29, 41, 42, 26, 18, 4, 15, 2, 30, 32,
    31, 3, 13, 33, 25, 20, 37, 34, 21];

// 34 (Affittacamere) is an Italian legal classification, offered only for properties in Italy
const italyOnlyPropertyTypeCodes = [34];

export {
    topPropertyTypeCodes,
    bottomPropertyTypeCodes,
    italyOnlyPropertyTypeCodes
};
